// extracted by mini-css-extract-plugin
export default {"container":"car_1IdbU"};